<template>
  <v-card tile flat class="my-5">
    <v-card-text class="pa-0">
      <v-row no-gutters>
        <v-col cols="2">
          <div class="bg-kiri"></div>
        </v-col>
        <v-col cols="10">
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" lg="6" class="py-0">
                    <v-list-item>
                      <v-list-item-avatar color="success">
                        <v-icon dark>mdi-google-classroom</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <div class="caption grey--text mb-0">Nama Kelompok</div>
                        <span class="body-1 black--text">
                          <strong> {{ $getDeepObj(detail, 'nama') || '-' }} </strong>
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" lg="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <div class="caption grey--text mb-0">Jadwal Berlangsung</div>
                        <span class="body-1 black--text">
                          <strong> {{ $getDeepObj(detail, 'nama') || '-' }} </strong>
                        </span>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-expansion-panels flat class="my-2">
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <template v-slot:default="{ open }">
                            <div>
                              <v-row no-gutters>
                                <v-col cols="12" lg="8" class="grey--text">
                                  <span class="blue--text subtitle-1 font-weight-medium">
                                    {{ ($getDeepObj(detail, 'psp_kp_pa_sekolahs.data') || []).length }}
                                  </span>
                                  Sekolah Anggota Pendampingan PA
                                </v-col>
                                <v-col cols="12" lg="4" class="text-right hidden-md-and-down my-auto">
                                  <span class="text-right blue--text mr-3">
                                    {{ open ? 'Sembunyikan Daftar' : 'Lihat Selengkapnya' }}
                                  </span>
                                </v-col>
                              </v-row>
                              <v-divider />
                            </div>
                          </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-row
                            v-for="(item, id) in $getDeepObj(detail, 'psp_kp_pa_sekolahs.data') || []"
                            :key="item.sekolah_id"
                          >
                            <v-col v-if="id !== 0" cols="12" class="py-0">
                              <v-divider class="mt-2" />
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                              <v-list-item class="px-0">
                                <v-list-item-avatar color="blue">
                                  <v-icon dark>mdi-hospital-building</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content class="py-0 px-1">
                                  <div class="blue--text body-1">
                                    {{ $getDeepObj(item, 'nama') || $getDeepObj(item, 'sekolah.data.nama') || '-' }}
                                  </div>
                                  <div class="black--text">
                                    <b>NPSN : </b>
                                    {{ $getDeepObj(item, 'npsn') || $getDeepObj(item, 'sekolah.data.npsn') || '-' }}
                                  </div>
                                  <div class="black--text">
                                    <b>Kepala Sekolah : </b>
                                    {{ $getDeepObj(item, 'psp_pelaksana.data.ptk.data.nama') || '-' }}
                                  </div>
                                </v-list-item-content>
                              </v-list-item>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                              <v-list-item class="px-0">
                                <v-list-item-content class="py-0">
                                  <div class="caption grey--text mb-0">Alamat Sekolah</div>
                                  <div class="black--text body-2">
                                    {{ $getDeepObj(item, 'alamat') || $getDeepObj(item, 'sekolah.data.alamat') || '-' }}
                                    <div>
                                      {{
                                        $getDeepObj(item, 'm_kota.data.keterangan') ||
                                          $getDeepObj(item, 'sekolah.data.m_kota.data.keterangan') ||
                                          ''
                                      }}
                                      <span v-if="item.k_kota || $getDeepObj(item, 'sekolah.data.k_kota')"> - </span>
                                      {{
                                        $getDeepObj(item, 'm_propinsi.data.keterangan') ||
                                          $getDeepObj(item, 'sekolah.data.m_propinsi.data.keterangan') ||
                                          '-'
                                      }}
                                    </div>
                                  </div>
                                </v-list-item-content>
                              </v-list-item>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'DetailKelompok',
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
